export default "__VITE_ASSET__693c2950__"